export type CharacterId = 'cow' | 'frog' | 'mouse'
export type Mode = 'trial' | 'endless'
export type State = 'menu' | 'playing' | 'paused' | 'upgrade' | 'won' | 'lost'
export type EnemyType = 'normal' | 'fast' | 'heavy' | 'boss'
export const CHARACTERS = {
  cow: { name: '牛来', role: '位移 · 家人援护', description: '冲刺穿过怪群；喊来妈妈护场，升级后豹拉加入追击。', hp: 170, speed: 6.2, damage: 22, radius: 1.0, tempo: 5, knockback: 10, skill: '妈妈来帮我', cooldown: 16 },
  frog: { name: '奶蛙', role: '范围 · 笑声清场', description: '站住也能笑倒一片；升级声波范围、连发与伤害。', hp: 105, speed: 4.8, damage: 15, radius: 1.15, tempo: 12, knockback: 4, skill: '大笑三连', cooldown: 9 },
  mouse: { name: '袋鼠', role: '控制 · 定住再打', description: '普通攻击减速，重击眩晕；控住怪群再收经验。', hp: 130, speed: 5.3, damage: 17, radius: 1.2, tempo: 7, knockback: 7, skill: '胆子别动了', cooldown: 10 },
} as const
export const ENEMIES = {
  normal: { hp: 36, speed: 1.75, damage: 9, radius: .6, exp: 2 },
  fast: { hp: 25, speed: 3.0, damage: 7, radius: .45, exp: 2 },
  heavy: { hp: 90, speed: 1.1, damage: 16, radius: .9, exp: 4 },
  boss: { hp: 520, speed: 1.6, damage: 25, radius: 1.65, exp: 15 },
} as const
export const UPGRADES = [
  { id: 'damage', name: '力大砖飞', text: '攻击伤害 +8', symbol: 'impact' },
  { id: 'radius', name: '膨胀一下', text: '攻击范围 +0.2', symbol: 'radius' },
  { id: 'speed', name: '脚底抹油', text: '移动速度 +0.7', symbol: 'speed' },
  { id: 'health', name: '再吃一口', text: '生命上限 +30，恢复 50 生命', symbol: 'heart' },
  { id: 'magnet', name: '经验自己来', text: '经验吸取范围 +1.5', symbol: 'magnet' },
  { id: 'knockback', name: '牛顿请假', text: '击退力度 +4', symbol: 'impact' },
  { id: 'spin', name: '越打越起劲', text: '攻击节奏 +25%，伤害 +3', symbol: 'spin' },
  { id: 'skill', name: '别等了再来', text: '主动技能冷却缩短 20%', symbol: 'clock' },
] as const
export type UpgradeId = typeof UPGRADES[number]['id'] | 'ability' | 'trait'
export const SIGNATURE_UPGRADES = {
  frog: { ability: { name: '笑到停不下来', text: '主动声波 +1、范围 +0.6、每波伤害 +12', symbol: 'sound' }, trait: { name: '笑声传得远', text: '普通声波范围 +0.45、伤害 +4', symbol: 'radius' } },
  cow: { ability: { name: '全家都来了', text: '援护 +2秒、伤害 +8；第2级召唤豹拉', symbol: 'cow' }, trait: { name: '越跑越牛', text: '冲刺冷却 -0.35秒、伤害 +10、距离增加', symbol: 'speed' } },
  mouse: { ability: { name: '罚站加时', text: '眩晕 +0.4秒、范围 +0.6、伤害 +12', symbol: 'clock' }, trait: { name: '软脚警告', text: '普攻减速 +0.4秒、短眩晕 +0.08秒', symbol: 'impact' } },
} as const
export function upgradeInfo(id: UpgradeId, character: CharacterId) {
  return id === 'ability' || id === 'trait' ? SIGNATURE_UPGRADES[character][id] : UPGRADES.find(u => u.id === id)!
}
